import { ws } from "../../../utils/common";

export const getShiftDetailsWS = async (id) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "shift/" + id,
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const removeSubscriptionVolunteerWS = async ({ id_shift, id_user }) => {
  const res = await ws(
    "DELETE",
    process.env.REACT_APP_ENDPOINT + "user-shift/" + id_shift,
    null,
    { id_user },
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const deleteShiftWS = async (id_shift) => {
  const res = await ws(
    "DELETE",
    process.env.REACT_APP_ENDPOINT + "shift/" + id_shift,
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const confirmSubscriptionShiftWS = async ({
  id_user_shift,
  confirmed,
}) => {
  const res = await ws(
    "PATCH",
    process.env.REACT_APP_ENDPOINT + "user-shift/confirm/" + id_user_shift,
    null,
    {
      confirmed,
    },
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};
